
export default {
    name: 'taux-examens',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    
    computed: {

    },

    mounted() {

    },

    methods: {

    }
}